import { Directive, ElementRef, HostListener, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[cursor-to-end]',
  standalone: false
})
export class CursorToEndDirective {
  
  constructor(private elementRef: ElementRef<HTMLInputElement>) {}


  @HostListener('focus')
  onFocus(): void {
    this.setCursorToEnd();
  }

  private setCursorToEnd(): void {
    const inputElement = this.elementRef.nativeElement;
    
    if (inputElement && inputElement.value) {
      const textLength = inputElement.value.length;
      
      requestAnimationFrame(() => {
        inputElement.setSelectionRange(textLength, textLength);
        inputElement.scrollLeft = inputElement.scrollWidth;
      });
    }
  }
}